import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	clientIdLabel: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	clientSecretLabel: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	remoteApplicationScopesLabel: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	remoteApplicationScopesPlaceholder: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	redirectUrlLabel: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	displayNameLabel: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	displayNamePlaceholder: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	displayNameHelperMessage: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	displayUrlLabel: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	displayUrlPlaceholder: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	displayUrlHelperMessage: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	applicationUrlLabel: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	applicationUrlPlaceholder: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	applicationUrlHelperMessage: {
		defaultMessage: string;
		id: string;
		description: string;
	};
} = defineMessages({
	clientIdLabel: {
		defaultMessage: 'App client ID',
		id: 'applinks.administration.ui.common.fields.client-id.label',
		description:
			'Label for the Client ID field. Also used in Copy button tooltip i.e. Copy "App Client ID".',
	},
	clientSecretLabel: {
		defaultMessage: 'App client secret',
		id: 'applinks.administration.ui.common.fields.client-secret.label',
		description:
			'Label for the Client Secret field. Also used in Copy button tooltip i.e. Copy "App Client Secret".',
	},
	remoteApplicationScopesLabel: {
		defaultMessage: 'Remote app scopes',
		id: 'applinks.administration.ui.common.fields.remote-application-scopes.label',
		description:
			'Label for the Remote App Scopes drop-down. The "Application" terminology should match Application URL',
	},
	remoteApplicationScopesPlaceholder: {
		defaultMessage: 'Use the same scopes as the remote app',
		id: 'applinks.administration.ui.common.fields.remote-application-scopes.placeholder',
		description:
			'Placeholder text for the Remote app Scopes drop-down, instructing the user which items to select',
	},
	redirectUrlLabel: {
		defaultMessage: 'Redirect URL',
		id: 'applinks.administration.ui.common.fields.redirect-url.label',
		description: 'Label for the Redirect URL field.',
	},
	displayNameLabel: {
		defaultMessage: 'Display name',
		id: 'applinks.administration.ui.common.fields.display-name.label',
		description: 'Label for the Display Name field.',
	},
	displayNamePlaceholder: {
		defaultMessage: 'Name for the application link',
		id: 'applinks.administration.ui.common.fields.display-name.placeholder',
		description: 'Placeholder text for the Display Name field.',
	},
	displayNameHelperMessage: {
		defaultMessage: 'Enter a unique name for the link, for example the name of your external app.',
		id: 'applinks.administration.ui.common.fields.display-name.helper-message',
		description: 'Helpful message displayed below the Display Name field.',
	},
	displayUrlLabel: {
		defaultMessage: 'Display URL',
		id: 'applinks.administration.ui.common.fields.display-url.label',
		description: 'Label for the Display URL field.',
	},
	displayUrlPlaceholder: {
		defaultMessage: 'URL for the application link',
		id: 'applinks.administration.ui.common.fields.display-url.placeholder',
		description: 'Placeholder text for the Display URL field.',
	},
	displayUrlHelperMessage: {
		// eslint-disable-next-line @atlassian/i18n/no-multiple-whitespaces
		defaultMessage: "This is the URL that we'll display to users in  {productName}.",
		id: 'applinks.administration.ui.common.fields.display-url.helper-message',
		description:
			'Helpful message displayed below the Display URL field. Product Name is the current product i.e. "Jira"',
	},
	applicationUrlLabel: {
		defaultMessage: 'Application URL',
		id: 'applinks.administration.ui.common.fields.application-url.label',
		description:
			'Label for the Application URL field. The "Application" terminology should match Application Scopes',
	},
	applicationUrlPlaceholder: {
		defaultMessage: 'Application URL for the application link',
		id: 'applinks.administration.ui.common.fields.application-url.placeholder',
		description: 'Placeholder text for the Application URL field.',
	},
	applicationUrlHelperMessage: {
		defaultMessage:
			'This is the URL that {productName} will use to communicate with the external app.',
		id: 'applinks.administration.ui.common.fields.application-url.helper-message',
		description:
			'Helpful message displayed below the Application URL field. Product Name is the current product i.e. "Jira"',
	},
});
export default messages;
